export const CUSTOM_EVENT_ID = 'searchBoxEvent'
export const VIEW_FULL = 'full'
export const VIEW_PANNEL = 'pannel'
export const VIEW_PREVIEW = 'preview'
export const MODULE_DESTINATION = 'destination'
export const MODULE_ROOMS = 'rooms'
export const MODULE_DATES = 'dates'
export const MODULE_SPECIAL_RATES = 'specialRates'

/**
 * Search Box lists limits
 */
export const LATEST_SEARCH_LIMIT = 5

export const KEYWORD_SEARCH_LENGTH = 3


/**
 * Types of filters
 */
export const FILTER_DATES = 'dates'
export const FILTER_ROOMS = 'rooms'
export const FILTER_MORE = 'more'
export const FILTER_SORT = 'sort'
export const FILTER_DESTINATION = 'destination'

/**
 * Show More filters filter if hotels results is more or equal this value
 * @type {number}
 */
export const FILTER_MORE_MIN_HOTELS_COUNT = 5

export const ACTIVE_NONE = ''


export const SEARCH_FILTERS_FORM = 'searchFiltersForm'

/**
 * Redux action types
 */
export const FILTER_CHANGE = 'SearchBox.FILTER_CHANGE';


export const LATEST_SEARCH_LOCAL_STORAGE = 'latestSearch'

export const LOADER_COLOR = '#40e9c4'

/** Search params */
export const SEARCH_PARAM_KEYWORD = 'q'
export const SEARCH_PARAM_DATE_START = 'dateIn'
export const SEARCH_PARAM_DATE_END = 'nbNight'
export const SEARCH_PARAM_ROOM = 'apartment[]'
export const SEARCH_PARAM_APPARTMENT = 'apartment'
export const SEARCH_PARAM_PRICE_RANGE = 'price_range'
export const SEARCH_PARAM_AMENITIES = 'amenities'
export const SEARCH_PARAM_HOTEL_TYPE = 'hotel_type'
export const SEARCH_PARAM_SORT = 'sort'
export const SEARCH_PARAM_APARTMENT_ID = 'apartment_id'
export const SEARCH_PARAM_HOTEL_DIRECT_ID = 'hotelDirectId'
export const CLIENT_CODE = 'clientCode';
export const CONTRACT_NUMBER = 'contractNumber';
export const PROMO_CODE = 'promoCode';
export const SEARCH_PARAM_IATA_CODE = 'iataCode'
export const SEARCH_PARAM_WRONGPROMO_CODE = 'wrongPromoCode'

export const BUTTON_OFF = '0'
export const BUTTON_ON = '1'

export const FETCH_CONDITIONS_REQUEST = 'SearchResults.FETCH_CONDITIONS_REQUEST'
export const FETCH_CONDITIONS_SUCCESS = 'SearchResults.FETCH_CONDITIONS_SUCCESS'
export const RESET_CONDITIONS_SUCCESS = 'SearchResults.RESET_CONDITIONS_SUCCESS'

/** Guests & Rooms */
export const ROOMS_MAX = 3
export const ADULTS_DEFAULT = 2
export const ADULTS_MIN = 1
export const ADULTS_MAX = 8

export const CHILDREN_DEFAULT = 0
export const CHILDREN_MIN = 0
export const CHILDREN_MAX = 5
export const CHILDREN_AGE_DEFAULT = null
export const CHILDREN_AGE_MIN = 0
export const CHILDREN_AGE_MAX = 17

export const BABIES_DEFAULT = 0
export const BABIES_MIN = 0
export const BABIES_MAX = 5

export const GLOBAL_LOADER_TOGGLE = 'GLOBAL_LOADER_TOGGLE'

export const GLOBAL_LOADER_TIMEOUT = 1000

/** Page View */
export const HOMEPAGE_VIEW = 'homePage'
export const SEARCHPAGE_VIEW = 'searchPage'

/** AB testy Cookie for home search filters */
export const TestAdagioABQA_HOMEPAGE_SEARCH_FILTERS = 'TestAdagioABQA'

/** AB testy Cookie for Hotel page Booking block */
export const TestAdagioABQA_HOTELPAGE_left = 'abt865903-1'
export const TestAdagioABQA_HOTELPAGE_right = 'abt865903-2'
